<div class="signature-content" [class.signature-v2]="isV2()">
	@if (isV2()) {
		<header class="signature-v2-header">
			<h2 class="signature-v2-title">{{ "SIGNATURE_MODAL__SIGN" | transloco }}</h2>
			<button
				type="button"
				class="signature-v2-close"
				(click)="cancel()"
				[attr.aria-label]="'NOTE_EDITOR__CLOSE' | transloco"
			>
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
					close
				</span>
			</button>
		</header>
	} @else {
		<ion-header>
			<ion-toolbar>
				<ion-title color="primary">{{ "SIGNATURE_MODAL__SIGN" | transloco }}</ion-title>
				<ion-buttons slot="end">
					<ion-button color="primary" (click)="cancel()">
						<ion-icon slot="icon-only" name="close"></ion-icon>
					</ion-button>
				</ion-buttons>
			</ion-toolbar>
		</ion-header>
	}

	<div class="signature-wrapper">
		<canvas #canvas></canvas>
	</div>

	<div class="modal-content-below" [class.signature-v2-below]="isV2()">
		<div class="signature-help-text">
			<span>{{ "SIGNATURE_MODAL__SIGN_ABOVE" | transloco }}</span>
		</div>
		@if (isV2()) {
			<div class="button-container">
				<button type="button" class="signature-v2-save" (click)="save()">
					{{ "SIGNATURE_MODAL__SAVE" | transloco }}
				</button>
			</div>
		} @else {
			<div class="button-container">
				<ion-button shape="round" (click)="save()" color="primary">
					{{ "SIGNATURE_MODAL__SAVE" | transloco }}
				</ion-button>
			</div>
		}
	</div>
</div>
